"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./input");
require("./volumeChannels");
const pixel_pigeon_1 = require("pixel-pigeon");
const run_1 = require("./run");
(0, pixel_pigeon_1.onRun)(run_1.run);
(0, pixel_pigeon_1.initialize)();
